import { persist, devtools } from "zustand/middleware";
import { create } from "./resettable-store";
import type { Gym } from "@/api/gyms/types";

export const GYM_STORAGE_KEY = "koachy-gym-storage";

export interface GymState {
  selectedGym: Gym | null;
  availableGyms: Gym[];
  setSelectedGym: (gym: Gym) => void;
  setAvailableGyms: (gyms: Gym[]) => void;
  clearSelectedGym: () => void;
}

export const useGymStore = create<GymState>()(
  devtools(
    persist(
      (set) => ({
        selectedGym: null,
        availableGyms: [],
        setSelectedGym: (gym) =>
          set({ selectedGym: gym }, false, "setSelectedGym"),
        setAvailableGyms: (gyms) =>
          set({ availableGyms: gyms }, false, "setAvailableGyms"),
        clearSelectedGym: () =>
          set({ selectedGym: null }, false, "clearSelectedGym"),
      }),
      {
        name: GYM_STORAGE_KEY,
        partialize: (state) => ({ selectedGym: state.selectedGym }),
      },
    ),
    { name: "gym-store" },
  ),
);

// Sentinel-ified selectedGym id, for call sites that need a plain number
// (e.g. as a query param) rather than dealing with the null case themselves.
export const useSelectedGymId = () =>
  useGymStore((state) => state.selectedGym?.id ?? 0);
